import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { LogBookItemsController } from './log-book-items.controller';
import { LogBookItems } from './log-book-items.entity';
import { LogBookItemsService } from './log-book-items.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([LogBookItems]),
  ],
  controllers: [LogBookItemsController],
  providers: [LogBookItemsService,ApplicationExceptionHandler]
})
export class LogBookItemsModule {}
